import React from "react";

import { animated, config, useSpring } from "@react-spring/web";

import { DropDownIcon } from "Atoms/Icons";

import useMeasure from "Helpers/useMeasure";

export const AccordionDropdown = ({
  children,
  title,
  isDefaultClosed = false,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
  isDefaultClosed?: boolean;
}) => {
  const [isOpen, setIsOpen] = React.useState(!isDefaultClosed);
  const [{ ref: measureRef }, bounds] = useMeasure();
  const style = useSpring({
    maxHeight: isOpen ? `${bounds.height}px` : "0px",
    config: config.slow,
  });

  return (
    <div className="space-y-12">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center cursor-pointer"
      >
        <div>{title}</div>
        <div className="text-venue-primary">
          <DropDownIcon isExpanded={isOpen} color="venue-primary" />
        </div>
      </div>
      <div className="flex gap-12">
        <animated.div
          className="flex-1"
          style={{ ...style, overflow: "hidden" }}
        >
          <div ref={measureRef}>{children}</div>
        </animated.div>
      </div>
    </div>
  );
};
